import React from 'react';

import FieldInformation from './FieldInformation';

require(`../assets/${process.env.PAGE}/css/components/custom-switch-input.css`);

const CustomSwitchInput = ({value, onChange, label, options, fieldInfo}) => {
    let moreInfo = fieldInfo ? (<FieldInformation title={fieldInfo.title} info={fieldInfo.info}/>) : '';
    return (
        <div className={'container-switch-input'}>
            <div className={'custom-switch-input'}>
                <span><p>{`${label}  `}{moreInfo}</p></span>
                <div className={'custom-switch-input-option'}> NO </div>
                <label className="switch">
                    <input type="checkbox" value={value} onChange={onChange}/>
                    <span className="slider round"></span>
                </label>
                <div className={'custom-switch-input-option'}> SI </div>
            </div>
        </div>
    );

}

export default CustomSwitchInput


/** WEBPACK FOOTER **
 ** ./src/components/CustomSwitchInput.js
 **/